<template>
    <div class="container mt-5">
        <h1>Join Us</h1>
        <p>
            Would you like to join our elite team? We're always looking for new attractive, reliable, intellectual,
            classy ladies with obvious charm and personality to join our friendly and successful team. Being attractive
            does not mean you must have model looks, however, we do require you to be in proportion. It is important
            that you are able to relax and have fun with people from a variety of different backgrounds. Also you must
            have a friendly, well-grounded, accommodating personality. Personality is just as important as looks.
        </p>

        <p>
            At Budapest Euro Escorts we allow our escorts to set their own rates and working hours, so if you are a
            student, work full time or are otherwise engaged during the daytime, you can still define your own
            availability and our agency will be as flexible as possible.
        </p>

        <p>
            We ensure that all our clients have total discretion and in return we offer this to every one of our escorts
            that cooperate with us. Please note you must be over 18 years old and expect you to have a good general
            education and be fluent in English. If you think you have what it takes to be the very best of the best and
            enjoy the high pay and privileges that a discrete elite companion demands, don't hesitate to get in touch.
        </p>

        <div class="row justify-content-center">
            <div class="col-md-6 sm-12">
                <vue-form :state="formstate" @submit.prevent="sendMessage">

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.name)">
                        <label>Your name</label>
                        <input type="text" name="name" class="form-control" required v-model.lazy="model.name">

                        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Name is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)">
                        <label>Email address</label>
                        <input type="email" name="email" class="form-control" required v-model.lazy="model.email">

                        <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Email address is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.phone)">
                        <label>Phone</label>
                        <input type="text" name="phone" class="form-control" required v-model.lazy="model.phone">

                        <field-messages name="phone" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Phone is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.age)">
                        <label>Age</label>
                        <input type="text" name="age" class="form-control" required v-model.lazy="model.age">

                        <field-messages name="age" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Age is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.weight)">
                        <label>Weight</label>
                        <input type="text" name="weight" class="form-control" required v-model.lazy="model.weight">

                        <field-messages name="weight" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Weight is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.height)">
                        <label>Height</label>
                        <input type="text" name="height" class="form-control" required v-model.lazy="model.height">

                        <field-messages name="height" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Height is required!</div>
                        </field-messages>
                    </validate>

                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.message)">
                        <label>Message</label>
                        <textarea rows="8" name="message" class="form-control" required
                                  v-model.lazy="model.message"></textarea>

                        <field-messages name="message" show="$touched || $submitted" class="form-control-feedback">
                            <div slot="required">Message is required!</div>
                        </field-messages>
                    </validate>

                    <button class="btn btn-dark" type="submit">Send message</button>
                </vue-form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "JoinUs",
        metaInfo: {
            title: 'Join Us'
        },
        data() {
            return {
                formstate: {},
                model: {
                    name: '',
                    email: '',
                    phone: '',
                    age: '',
                    weight: '',
                    height: '',
                    photo: '',
                    message: '',
                }
            }
        },
        methods: {
            sendMessage: function () {
                let formData = new FormData();
                formData.append('file', this.file);

                if (this.formstate.$valid) {
                    this.$http.post(`${process.env.VUE_APP_API_URL}/join-us`, this.model)
                        .then(() => {
                            this.$bvModal.msgBoxOk('Your message has been sent!');
                            this.model.name = '';
                            this.model.email = '';
                            this.model.phone = '';
                            this.model.age = '';
                            this.model.weight = '';
                            this.model.height = '';
                            this.model.message = '';
                        }).catch(() => {
                        this.$bvModal.msgBoxOk('Error sending email!')
                    })
                }
            },
            fieldClassName: function (field) {
                if (!field) {
                    return '';
                }
                if ((field.$touched || field.$submitted) && field.$valid) {
                    return 'has-success';
                }
                if ((field.$touched || field.$submitted) && field.$invalid) {
                    return 'has-danger';
                }
            },
        }
    }
</script>

<style scoped>

</style>
